export default __webpack_public_path__ + "static/media/emergency.d999a084.svg";